export var FeatureFlagEnum;
(function (FeatureFlagEnum) {
    // Brian added this on 10/24/22 expected to remove in 11/2022
    FeatureFlagEnum["RELEASE_GATE_CAMPAIGN_SETTINGS"] = "release-gate-character-sheet-campaign-settings";
    // Tim added this on 02/23/23 expected to remove in ??
    FeatureFlagEnum["RELEASE_GATE_CHARACTER_SHEET_TOUR"] = "release-gate-character-sheet-tour";
    // Brittany added this on 2/24/2023
})(FeatureFlagEnum || (FeatureFlagEnum = {}));
export const FEATURE_FLAG_LIST = [
    FeatureFlagEnum.RELEASE_GATE_CAMPAIGN_SETTINGS,
    FeatureFlagEnum.RELEASE_GATE_CHARACTER_SHEET_TOUR,
];
export const DEFAULT_FEATURE_FLAG_INFO = {
    [FeatureFlagEnum.RELEASE_GATE_CAMPAIGN_SETTINGS]: false,
    [FeatureFlagEnum.RELEASE_GATE_CHARACTER_SHEET_TOUR]: false,
};
